import React from "react";
import styled from "@emotion/styled";
import { fieldLabel, formatValue } from "../utils/format";

/**
 * before/after 비교 + 충돌 감지된 필드 강조.
 * conflict 예: { price: { requested_before: 1000, current: 1200 } }
 *              { branches: { requested_before: [1,2], current: [1,2,3] } }
 *
 * branchesResolved (id → {id,name}) 가 있으면 branches 필드를 이름으로 표시.
 */
function DiffTable({ before, after, conflict, branchesResolved }) {
  const fields = Object.keys(after || {});
  return (
    <Wrapper>
      <Head>
        <Cell />
        <Cell>요청 시점</Cell>
        <Cell>변경값</Cell>
      </Head>
      {fields.map((f) => {
        const conflicted = conflict && conflict[f];
        return (
          <Row key={f} conflicted={!!conflicted}>
            <Cell strong>{fieldLabel(f)}</Cell>
            <Cell>
              <Old>{formatValue(f, before?.[f], branchesResolved)}</Old>
              {conflicted && (
                <ConflictNow>
                  현재 DB:{" "}
                  <strong>
                    {formatValue(f, conflicted.current, branchesResolved)}
                  </strong>
                </ConflictNow>
              )}
            </Cell>
            <Cell>
              <New>{formatValue(f, after?.[f], branchesResolved)}</New>
            </Cell>
          </Row>
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e8eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
`;
const Head = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 1fr;
  font-size: 12px;
  color: #888;
  background: #f6f7f9;
  padding: 8px 12px;
`;
const Row = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr 1fr;
  padding: 12px;
  gap: 8px;
  border-top: 1px solid #f0f1f3;
  background: ${({ conflicted }) => (conflicted ? "#fff7e6" : "transparent")};
`;
const Cell = styled.div`
  font-size: 14px;
  color: #222;
  font-weight: ${({ strong }) => (strong ? 500 : 400)};
  word-break: break-word;
`;
const Old = styled.div`
  color: #888;
  text-decoration: line-through;
`;
const New = styled.div`
  color: #003580;
  font-weight: 500;
`;
const ConflictNow = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #a35d00;
  strong {
    color: #a35d00;
    font-weight: 600;
  }
`;

export default DiffTable;
